// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"167":"2dc93fc6","720":"c9b2a89a"}[chunkId] + ".chunk.js";
};